import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    counterBlock: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    title: {
        textAlign: "left",
    },
    titleText: {
        color: theme.palette.primary.dark,
        margin: 0,
        textAlign: "left",
    },
    clock: {
        color: theme.palette.text.primary,
        textAlign: "left",
    },
}));
